import { getProfilePicture, getUserData } from "@/services/v1/studentV1.service";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";


const initialState = {
    userInfo: {},
    educationDetails: {},
    profileview: null,
    videoview: null,
    error: null,
};
 
export const fetchStudentData = createAsyncThunk(
    'student/fetchStudentData',
    async (_, {dispatch, rejectWithValue }) => {
        try {
            const response = await getUserData();
            getProfilePicture(response?.data?.profilePic, dispatch);
            return response;
            
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const studentSlice = createSlice({
    name: "student",
    initialState,
    reducers: {
        signOut:(state)=>{
            state.userInfo = {};
            state.educationDetails = {};
            state.profileview = null;
            state.videoview = null;
            state.error = null;
        },
        getuserdata: (state, action) => {
            state.userInfo = action.payload; 
            state.error = null;
            return state;
        },
        getEducationDetails: (state, action) => {
            state.educationDetails = action.payload;
            state.error = null;
            return state;

        },
        getProjects: (state, action) => {
            state.userInfo.projects = action.payload;
            state.error = null;
            return state;

        },
        getAchievements: (state, action) => {
    if (!state.userInfo.achievements) {
        state.userInfo.achievements = []; // Initialize if undefined
    }
    state.userInfo.achievements = action.payload;
    state.error = null;
    return state;
},

        getExperiences: (state, action) => {
            state.userInfo.experiences = action.payload;
            state.error = null;
            return state;
        },
        getUserProfile: (state, action) => {
            state.profileview = action.payload;
            state.error = null;
            return state;
        },
        getvideoresume:(state,action)=>{
            state.videoview = action.payload;
            state.error = null;
            return state;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchStudentData.fulfilled, (state, action) => {
                state.userInfo = action.payload.data;
                state.error = null;
                return state;
            })
            .addCase(fetchStudentData.rejected, (state, action) => {
                state.error = action.payload;  // Handle the error
            });
    },
})

export const {
  signOut,
  getuserdata,
  getEducationDetails,
  getProjects,
  getAchievements,
  getExperiences,
  getUserProfile,
  getvideoresume
} = studentSlice.actions;
export default studentSlice.reducer;
